// noinspection JSUnusedGlobalSymbols

import Helper from '../../../client/helper.js'
import Network from '../../../client/network.js'

export default class
{
	static type(imported = false)
	{
		$('table.__edit tr').show()
		if(!imported) $('table.__edit input').prop('disabled', false)

		switch($('select#type').val())
		{
			case 'discount' :
				$('._not_discount').hide()
				$('._not_discount input').prop('disabled', true)
			break

			case 'item' :
				$('._discount, ._not_item').hide()
				$('._discount input, ._not_item input').prop('disabled', true)
			break

			default :
				$('._discount').hide()
				$('._discount input').prop('disabled', true)
			break
		}
	}

	static sync_portal()
	{
		Helper.confirm(Helper.message('#message-import_confirm'), () =>
		{
			const data = new FormData()
			data.set('__action', 'download')

			Network.post(location.pathname, data, undefined, false)
		})
	}
}
